import React from "react";
import { AUTH_SIGNUP, AUTHENTICATION_MODAL_ID } from "../../../redux/authentication/constants";
import { store } from "../../../redux";
import { setAuthState } from "../../../redux/actions";

export const Identity = () => {
  return (
    <div className="members-body">
      <section className="members-section">
        <div className="container">
          <h1 className="heading">Who is on Radivision?</h1>
          <div className="benefits-section">
            <div className="card">
              <h2>
                Startup Enthusiasts <span>Benefits</span>
              </h2>
              <ul>
                <li>Be inspired by entrepreneurs creating powerful solutions</li>
                <li>Learn about private market & IPO opportunities to grow your wealth</li>
                <li>Discover startups aligned with your values</li>
                <li>Gain insights on startups & their teams</li>
                <li>Access private wealth opportunities like the top 10%</li>
                <li>Become an Angel investor</li>
              </ul>
            </div>
            <div className="card">
              <h2>
                Startup Founders <span>Benefits</span>
              </h2>
              <ul>
                <li>Empower investor relations (IR) & funding success</li>
                <li>Connect directly with individual investors & $20T AUM new funding</li>
                <li>Grow an inspired community, brand & business</li>
                <li>Engage with individuals aligned with your vision</li>
                <li>Leverage new regulations & millions in new funding</li>
                <li>Access resources & vendors dedicated to your success</li>
              </ul>
            </div>
          </div>

          <div className="getting-started-header">
            <div className="gs-btn">
              <button
                data-toggle="modal"
                data-backdrop="static"
                data-keyboard="false"
                data-target={`#${AUTHENTICATION_MODAL_ID}`}
                onClick={() => {
                  store.dispatch(setAuthState({ step: AUTH_SIGNUP }));
                }}
              >
                Join
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
